import React, { useState, useEffect, useRef } from 'react'
import {  Modal,  Row, Col, Form, Input,  App } from 'antd'
import { useKehuUpdateQuery, useKehuUpdateSaveMutation } from '../../store/DianShangYeWuApi';
import classes from './client.module.css';
import Icon from '../../cpn/Icon';
import ClientTypeSelect from '../clientType/ClientTypeSelect';
import ClientBankList from './ClientBankList';
import ClientContactList from './ClientContactList';
import ClientInvoiceList from './ClientInvoiceList';
function ClientCheck(props) {
    const { message } = App.useApp();
    const [form] = Form.useForm();  
    const editForm = useRef(null);
    const [open, setOpen] = useState(false)
    const [info, setInfo] = useState({
        'kh_qy_id': props.qy_id,
        'kh_qy_name': props.qy_name,
        'kh_name': props.kh_name,
        'kh_cid': props.yh_id,
        'kh_cname': props.yh_name,
        'kh_type_id': props.kh_type_id,
        'kh_type_name': props.kh_type_name,
        'kh_remark': props.kh_remark,
        'kh_id': props.kh_id,
    })
    const { data, isSuccess } = useKehuUpdateQuery({ kh_id: props.kh_id }, { skip: !open, refetchOnMountOrArgChange: 1 })
    useEffect(() => {
        if (isSuccess) {
            setInfo(data.Result)
            form.setFieldsValue({
                kh_name: data.Result.kh_name,
                kh_type_name: data.Result.kh_type_name,
            })
        }
    }, [data, isSuccess, form])
    const [kehuupdate] = useKehuUpdateSaveMutation()
    
    
    
    return (
        <>
            {props.type === 'button' ? <Icon type='add'  onClick={() => setOpen(true)}/> : <a onClick={() => setOpen(true)}>{props.kh_name}</a>}
            <Modal
                open={open}
                onCancel={() => setOpen(false)}
                width={1080}
                footer={null}
            >
                <div style={{maxWidth: '1080px',display:'flex',flexDirection:'column',alignItems:'center'}}>
                    <Row style={{width:'1080px'}}>
                        <Col span={3}></Col>
                        <Col span={18}><div style={{fontSize: '18px', fontWeight: 'bold', textAlign: 'center', marginBottom: '10px'}}>客户信息采集表</div></Col>
                        <Col span={3}></Col>
                    </Row>
                    <Form
                        form={form}
                        layout="horizontal"
                        name="form_client_check"
                        initialValues={{modifier: 'public',}}
                        labelCol={{ span: 3}}
                        wrapperCol={{ span: 21 }}   
                        variant='filled'
                        size='middle'
                        ref={editForm}                        
                        style={{ maxWidth: 1080 }}
                    >
                        <Row  style={{width:"1000px"}}>
                            <Col span={2} className={classes.col_top_label} style={{borderLeft: '3px solid #000', borderTop: '3px solid #000',}}>客户名称</Col>
                            <Col span={6} style={{borderTop: '3px solid #000'}} className={classes.col_top_input}>
                                <Form.Item name="kh_name" wrapperCol={{span:10}} style={{marginBottom: 0,width: '100%'}}>                        
                                    <Input style={{width: '240px'}} onChange={(e) => {
                                        setInfo(prevState=>({...prevState,kh_name:e.target.value}))
                                    }}/>
                                </Form.Item>
                            </Col>
                            <Col span={2} className={classes.col_top_label} style={{borderTop: '3px solid #000',}}>客户类型</Col>
                            <Col span={6} style={{borderTop: '3px solid #000',}} className={classes.col_top_input}>
                                <ClientTypeSelect
                                    name="kh_type_name"
                                    wrapperCol={{span:10}}
                                    qy_id={props.qy_id}
                                    qy_name={props.qy_name}
                                    yh_id={props.yh_id}
                                    yh_name={props.yh_name}
                                    formStyle={{marginBottom: 0,width: '100%'}}
                                    style={{width: '240px'}}
                                    onChange={(e,f) => {
                                        setInfo(prevState=>({...prevState,kh_type_id:e,kh_type_name:f}))
                                    }}
                                />
                            </Col>
                            <Col span={2} className={classes.col_top_label} style={{borderTop: '3px solid #000',}}>备注</Col>
                            <Col span={6} style={{borderTop: '3px solid #000',borderRight: '3px solid #000'}} className={classes.col_top_input}>
                                <Form.Item name="kh_remark" wrapperCol={{span:10}} style={{marginBottom: 0,width: '100%'}}>                        
                                    <Input style={{width: '240px'}} onChange={(e) => {
                                        setInfo(prevState=>({...prevState,kh_remark:e.target.value}))
                                    }}/>
                                </Form.Item>
                            </Col>
                            <Col span={2} className={classes.col_top_label} style={{borderLeft: '3px solid #000', borderBottom: '3px solid #000'}}>新增记录</Col>
                            <Col span={6} style={{borderBottom: '3px solid #000'}} className={classes.col_top_input}>{info.kh_ctime}{info.kh_cname}</Col>
                            <Col span={2} className={classes.col_top_label} style={{borderBottom: '3px solid #000'}}>修改记录</Col>
                            <Col span={6} style={{borderBottom: '3px solid #000'}} className={classes.col_top_input}>{info.kh_update_time}{info.kh_update_uname}</Col>
                            <Col span={2} className={classes.col_top_label} style={{borderBottom: '3px solid #000'}}>编号</Col>
                            <Col span={6} style={{borderBottom: '3px solid #000',borderRight: '3px solid #000'}} className={classes.col_top_input}>{info.kh_id}</Col>
                        </Row>     
                        <div style={{width:'1000px',display:'flex',justifyContent:'flex-end',alignItems:'center',marginTop:'10px'}}>
                            <Icon type='save' onClick={() => {
                                kehuupdate(info).then(res => {
                                    if(res.data.Status === 'success'){
                                        message.success('修改成功');
                                    }else{
                                        message.error('修改失败'+res.data.Message);
                                    }
                                });
                                form.submit();
                            }}/>
                        </div>                   
                    </Form>
                    <ClientContactList 
                        kh_id={props.kh_id} 
                        yh_id={props.yh_id} 
                        yh_name={props.yh_name} 
                        kh_name={info.kh_name}
                        qy_id={props.qy_id}
                        qy_name={props.qy_name}
                    />
                    <ClientBankList 
                        kh_id={props.kh_id} 
                        yh_id={props.yh_id} 
                        yh_name={props.yh_name} 
                        kh_name={info.kh_name}
                        qy_id={props.qy_id}
                        qy_name={props.qy_name}
                    />
                    <ClientInvoiceList 
                        kh_id={props.kh_id} 
                        yh_id={props.yh_id} 
                        yh_name={props.yh_name} 
                        kh_name={info.kh_name}
                        qy_id={props.qy_id}
                        qy_name={props.qy_name}
                    />
                    
                </div>
            </Modal>
        </>
    )
}

export default ClientCheck